import { redirectReplace } from '../../../../core/store/actions/HistoryRouting';
import { PAGE_ROUTES } from '../../../../constants/pageRoutes';

export function navigateToList() {
    redirectReplace(PAGE_ROUTES.REPORTED_COMPANIES);
}
